const initialState = {
	"listaMensajes": {},
	"visible": false,
	"codigo": false,
	"accion": "",
	"titulo": "ERROR",
	"mensaje": "SERVICIO NO DISPONIBLE"
};

export function modalAlertRdc(state = initialState, action) {
	switch (action.type) {
	case "MODAL_ALERT_LISTA":
		return {...state,
			"listaMensajes": action.listaMensajes
		};
	case "MODAL_ALERT_SHOW": 
		return {...state,
			"visible": true
		};
	case "MODAL_ALERT_HIDE": 
		return {...state,
			"visible": false
		};
	case "MODAL_ALERT_TOGGLE": 
		return {...state,
			"visible": !state.visible
		};
	case "MODAL_ALERT_TITULO":
		return {...state,
			"titulo": action.titulo
		};
	case "MODAL_ALERT_MENSAJE":
		return {...state,
			"mensaje": action.mensaje
		};
	case "MODAL_ALERT_MESSAGES":
		return {...state,
			"titulo": action.titulo,
			"mensaje": action.mensaje,
		};
	case "MODAL_ALERT_CODE_SHOW":
		let codigo = (typeof action.codigo == "string")? action.codigo.toUpperCase() : "";
		let sCodigo = (state.listaMensajes[codigo] != undefined)? state.listaMensajes[codigo] : "SERVICIO TEMPORALMENTE NO DISPONIBLE";
		let fnAccion = (action.accion)? action.accion : "";
		return {...state,
			"visible": true,
			"titulo": "ERROR",
			"mensaje": sCodigo,
			"codigo": action.codigo,
			"accion": fnAccion
		};
	case "MODAL_ALERT_MESSAGES_SHOW":
		return {...state,
			"visible": true,
			"titulo": action.titulo,
			"mensaje": action.mensaje,
		};
	case "MODAL_ALERT_MESSAGES_ACTION_SHOW":
		return {...state,
			"visible": true,
			"titulo": action.titulo,
			"mensaje": action.mensaje,
			"accion": action.accion
		};			
	case "MODAL_ALERT_RESET":
		return {...state,
			"visible": false,
			"codigo": false,
			"accion": "",
			"titulo": "ERROR",
			"mensaje": "SERVICIO TEMPORALMENTE NO DISPONIBLE"
		};
		case "MODAL_ALERT_CONFIRM":
			return {
				...state,
				"visible": true,
				"codigo": action.codigo,
				"titulo": action.titulo,
				"mensaje": action.mensaje,
				"nameBtnCancel":action.nameBtnCancel,
				"accionCancel":action.accionCancel,
				"nameBtnConfirm":action.nameBtnConfirm,
				"accionConfirm":action.accionConfirm,
			};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/modal-alert/reducer.js